import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipListControllerModule } from './controllers/MembershipListController';

export const MembershipListView = angular
  .module('acme.view.application.membership.list', [uiRouter, 'ui.bootstrap', MembershipListControllerModule])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const membershipList = {
      name: 'application.membership.list',
      url: '/members',
      views: {
        'subview-main': {
          controller: 'MembershipListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Members',
        enablePreferences: true,
      },
    };

    $stateProvider.state(membershipList);
  }).name;
